export const manifest = {
  screens: {
    scr_h5d80f: { name: "Follow-up Queue", route: "/", position: {"x":1560,"y":2200} },
    scr_nnyz28: { name: "Real-Time Leads", route: "/realtime", position: {"x":2960,"y":2200} },
    scr_7yrxwd: { name: "Campaigns", route: "/campaigns", position: {"x":160,"y":4180} },
  },
  sections: {
    sec_4bsut2: { name: "Dashboard", x: 0, y: 0, width: 1520, height: 1180 },
    sec_194uvh: { name: "Lead Management", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_nd3mwt: { name: "Campaign Management", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_73cnqz: { name: "Application Processing", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_mzz96q: { name: "Calendar & Scheduling", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_5j9o3q: { name: "Reports & Analytics", x: 0, y: 9900, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_4bsut2", children: [] },
    { kind: "section", id: "sec_194uvh", children: [
      { kind: "screen", id: "scr_h5d80f" },
      { kind: "screen", id: "scr_nnyz28" },
    ] },
    { kind: "section", id: "sec_nd3mwt", children: [
      { kind: "screen", id: "scr_7yrxwd" },
    ] },
    { kind: "section", id: "sec_73cnqz", children: [] },
    { kind: "section", id: "sec_mzz96q", children: [] },
    { kind: "section", id: "sec_5j9o3q", children: [] },
  ],
}
